module.exports = __webpack_public_path__ + "static/media/Artboard4.403add9a.png";